module.exports = __webpack_public_path__ + "static/media/coursera.3952f41b.png";